<template>
  <div>
    <!-- PACKER/ROLLOFF -->
    <div v-if="order.requestType !== 'Mini Pickup/Dropoff'">
      <strong
        >{{ order.requestType
        }}<span v-if="order.fullLoad">
          - {{ order.fullLoadsQty }} Full Load<span
            v-if="order.fullLoadsQty > 1"
            >s</span
          ></span
        >
        <span v-if="order.numberOfTrucks > 1" class="caption">
          ({{ order.numberOfTrucks }} {{ order.requestType }}s)</span
        >
      </strong>
      <span v-if="order.qtyType">
        -
        <span v-if="order.requestType == 'Roll Off'">{{
          order.pickupType
        }}</span>
        {{ order.qty || "" }} {{ order.qtyType }}
      </span>
      <div>
        Material:
        {{
          order.materialTypeBreakdown && order.materialTypeBreakdown.length
            ? order.materialTypeBreakdown.map((m) => m.material).join(", ")
            : order.materialType.join(", ")
        }}
      </div>
    </div>
    <!-- MINI CONTAINER -->
    <div v-else>
      <strong>{{ order.requestType }}</strong>
      <div>
        <span v-if="order.miniPickupQty"
          >Pickup
          <strong style="border-bottom: solid 1px gray;">{{
            order.miniPickupQty
          }}</strong></span
        >
        <span v-if="order.miniPickupQty && order.miniDropoffQty">
          &
        </span>
        <span v-if="order.miniDropoffQty"
          >Drop Off
          <strong style="border-bottom: solid 1px gray;">{{
            order.miniDropoffQty
          }}</strong></span
        >
      </div>
    </div>
    <div v-if="order.duration" class="grey--text">
      <strong>Duration:</strong>
      {{ order.duration }}
    </div>
    <div v-if="order.notes && showNotes" class="grey--text">
      <div style="max-width:400px">
        <strong>Notes: </strong>
        <em>{{ order.notes }}</em>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["showNotes", "order"],
  data() {
    return {};
  },
};
</script>
